module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCondMed-Italic.e7a4bcbb.ttf";